import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { LanguageService } from 'src/app/services/lang.service';

@Component({
  selector: 'app-rename-project-dialog',
  templateUrl: './rename-project-dialog.component.html',
  styleUrls: ['./rename-project-dialog.component.scss'],
})
export class RenameProjectDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<RenameProjectDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public langService: LanguageService
  ) {}

  onNoClick(): void {
    this.dialogRef.close();
  }
}
